export default "__VITE_ASSET__da6e7e0c__"